export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";